import { createContext } from "react";

import { AssetCommentStatuses } from "@hightouch/lib/llm/asset-comments/types";

import type { AmpLibraryFileFragment } from "src/graphql";
import type { CanvasCommentThread } from "src/pages/projects/library/canvas/canvas-comment-threads";

/**
 * Whether an agent is at work on a file: making it, or owing a reply in one of its threads. Not while it only decides
 * whether to answer, which waits for the end of whatever turn its session is on, maybe on another file.
 */
export const isAgentWorkingOn = (
  file: Pick<AmpLibraryFileFragment, "generationStatus">,
  threads: readonly {
    comments: readonly Pick<
      CanvasCommentThread["comments"][number],
      "current_status"
    >[];
  }[],
) =>
  file.generationStatus === "generating" ||
  threads.some(({ comments }) =>
    comments.some(
      ({ current_status }) => current_status === AssetCommentStatuses.Pending,
    ),
  );

/** The canvas nodes that the chat's running threads work on. */
export function nodesWorkedByThreads(
  runningThreadIds: ReadonlySet<string>,
  targets: ReadonlyMap<string, string[]>,
): ReadonlySet<string> {
  return new Set(
    [...runningThreadIds].flatMap((threadId) => targets.get(threadId) ?? []),
  );
}

/** The nodes an agent is working on from the chat, for a tile to show it. */
export const ChatWorkedNodesContext = createContext<ReadonlySet<string>>(
  new Set(),
);
